import { FormControlLabel, Radio, styled } from '@mui/material';

import type {
  ChkOptionButtonProps,
  StyledOptionButtonProps,
} from './ChkOptionButton.types';

export const ChkOptionButton = ({
  value,
  selected,
  label,
}: ChkOptionButtonProps) => {
  return (
    <Option
      value={value}
      control={<Radio checked={selected} disableRipple />}
      checked={selected}
      label={label}
    />
  );
};

const Option = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'checked',
})<StyledOptionButtonProps>(({ theme, checked }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(4, 5),
  gap: theme.spacing(5),
  width: '100%',
  border: theme.borders.borderWidth1,
  borderColor: theme.tokens.optionCardsBorderDefault,
  borderRadius: theme.borders.borderRadius2,
  backgroundColor: theme.tokens.optionCardsBackgroundDefault,
  color: theme.tokens.optionCardsValueHeader,
  transition: 'background-color 150ms ease-in, border-color 150ms ease-in',
  margin: theme.spacing(3, 0, 0, 0),

  '& .MuiFormControlLabel-label': {
    width: '100%',
  },

  '& .PrivateSwitchBase-root': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
  },

  '& .MuiSvgIcon-root': {
    display: 'none',
  },

  '&:hover': {
    borderColor: theme.tokens.optionCardsBorderHover,
    backgroundColor: theme.tokens.optionCardsBackgroundHover,
  },

  '&:focus-within': {
    borderColor: theme.tokens.optionCardsBorderActive,
  },

  ...(checked && {
    borderColor: theme.tokens.optionCardsBorderActive,
    backgroundColor: theme.tokens.optionCardsBackgroundHover,
    color: theme.tokens.optionCardsValueHeader,

    '&:hover, &:focus-visible': {
      borderColor: theme.tokens.optionCardsBorderActive,
      backgroundColor: theme.tokens.optionCardsBackgroundHover,
    },
  }),
}));
